import type {
  PersonalSkillDraft,
  ResolvedSkillDetail,
  ResolvedSkillMetadata,
  SkillSettingsEntry,
} from '@hector/shared-types';
import { apiClient } from '@/lib/apiClient';

interface SettingsResponse {
  success: true;
  skills: SkillSettingsEntry[];
}

interface CatalogResponse {
  success: true;
  mode: string;
  skills: ResolvedSkillMetadata[];
}

interface SkillResponse {
  success: true;
  skill: ResolvedSkillDetail;
}

const BASE = '/skills';

export const skillsApi = {
  async listSettings(): Promise<SkillSettingsEntry[]> {
    const response = await apiClient.get<SettingsResponse>(`${BASE}/personal`);
    return response.skills;
  },

  async listCatalog(): Promise<ResolvedSkillMetadata[]> {
    const response = await apiClient.get<CatalogResponse>(`${BASE}?mode=casediscovery`);
    return response.skills;
  },

  async create(draft: PersonalSkillDraft): Promise<ResolvedSkillDetail> {
    const response = await apiClient.post<SkillResponse>(`${BASE}/personal`, draft);
    return response.skill;
  },

  async update(currentSlug: string, draft: PersonalSkillDraft): Promise<ResolvedSkillDetail> {
    const response = await apiClient.put<SkillResponse>(
      `${BASE}/personal/${encodeURIComponent(currentSlug)}`,
      draft,
    );
    return response.skill;
  },

  async setActive(slug: string, isActive: boolean): Promise<ResolvedSkillDetail> {
    const response = await apiClient.patch<SkillResponse>(
      `${BASE}/personal/${encodeURIComponent(slug)}/active`,
      { isActive },
    );
    return response.skill;
  },

  async reset(slug: string): Promise<ResolvedSkillDetail> {
    const response = await apiClient.post<SkillResponse>(
      `${BASE}/personal/${encodeURIComponent(slug)}/reset`,
      {},
    );
    return response.skill;
  },

  async delete(slug: string): Promise<void> {
    await apiClient.delete(`${BASE}/personal/${encodeURIComponent(slug)}`);
  },
};
